import { render, staticRenderFns } from "./InformationMessage.vue?vue&type=template&id=153e949d"
import script from "./InformationMessage.vue?vue&type=script&lang=js"
export * from "./InformationMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports